import { filesize } from 'filesize';

const fhr = (value, locale) => {
  const params = { locale };
  if (!value) {
    return filesize(0, params);
  }
  return filesize(value, params);
};

export default function useFileSize() {
  /********************
   * FUNCTIONS         *
   ********************/
  function filesizeHumanReadable(value, locale) {
    return fhr(value, locale);
  }

  return {
    filesizeHumanReadable,
  };
}
